import { VehicleEquipmentFormula } from '../../../models/vehicle-equipment-formula';

export function hasNextStepInLevel({
  currentStepIndex,
  steps,
}: Pick<VehicleEquipmentFormula, 'currentStepIndex' | 'steps'>): boolean {
  return currentStepIndex + 1 < steps.length;
}
